import { NgModule } from "@angular/core";
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DemoMaterialModule } from "material-module";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        DemoMaterialModule
    ],
    declarations: [

    ],
    exports: [
        DemoMaterialModule
    ]
})


export class AllModule {

}
